export default __webpack_public_path__ + "653cdafb7e322e437f11a6dd86eaec2d.png";